import { render, staticRenderFns } from "./view-request-files.vue?vue&type=template&id=7f103004&"
import script from "./view-request-files.vue?vue&type=script&lang=js&"
export * from "./view-request-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports